import { render } from "./WishlistPickerDialog.vue?vue&type=template&id=5ee26038"
import script from "./WishlistPickerDialog.vue?vue&type=script&lang=js"
export * from "./WishlistPickerDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__